import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';

interface Props {
    show: boolean;
    onToggle: (isOpen: boolean) => void;
    onSelect: (range: string) => void;
    selectedRange: any;
    cycleRanges: any[];
    cycleId: string
}

interface State {
    searchTerm: string;
}

class DateRangeDropdown extends Component<Props, State> {
    state: State = {
        searchTerm: '',
    };
    dropdownRef = React.createRef<HTMLDivElement>();
    //   ranges: DateRangeItem[] = [
    //     { label: '7/1/23 to 9/31/23', status: 'In Progress', type: 'current' },
    //     { label: '4/1/23 to 6/31/23', status: 'Skipped', type: 'previous' },
    //     { label: '1/1/23 to 3/31/23', status: 'Completed', type: 'previous' },
    //   ];

    badgeStyle = (status: string) => {
        switch (status) {
            case 'In Progress': return '#065A8C';
            case 'Skipped': return 'warning';
            case 'Completed': return '#0e9074';
            default: return 'secondary';
        }
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event: MouseEvent) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target as Node)) {
            this.setState({ searchTerm: '' });
        }
    };
    handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchTerm: e.target.value });
    };

    filterRanges = (type: 'current' | 'previous') => {
        const { searchTerm } = this.state;
        const { cycleRanges } = this.props;
        return cycleRanges
            .filter(r => r.type === type)
            .filter(r => r.label.toLowerCase().includes(searchTerm.toLowerCase()));
    };

    render() {
        const { show, onToggle, onSelect, selectedRange, cycleId } = this.props;
        const currentRanges = this.filterRanges('current');
        const previousRanges = this.filterRanges('previous');
        const noMatches = currentRanges.length === 0 && previousRanges.length === 0;
        return (
            <div ref={this.dropdownRef}>

            <Dropdown show={show} onToggle={onToggle} className="custom-dropdown">
                <Dropdown.Toggle id="groups-dropdown" className="border-0">
                    <div className='d-flex flex-class align-items-center'>
                        <div className={`selected-val ${selectedRange ? "selected" : ""}`}>{selectedRange ? selectedRange : 'Select Date Range'}</div>
                        <div className='arrow ml-auto'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 12.8124L5 7.81242L6.16667 6.64575L10 10.4791L13.8333 6.64575L15 7.81242L10 12.8124Z" fill="#1D1E20" />
                            </svg>
                        </div>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ width: '300px', maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
                    <div className="">
                        <input
                            className="form-control search-input"
                            placeholder="Filter Search"
                            value={this.state.searchTerm}
                            onChange={this.handleSearchChange}
                        />

                        {/* Current Section */}
                        {currentRanges?.length > 0 && (
                            <>
                        <small className="text-muted">CURRENT</small>
                        {currentRanges.map((item, index) => (
                                <Dropdown.Item
                                    key={index}
                                    active={cycleId === item.cycleId}
                                    onClick={() => onSelect(item)}
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{item.label}</span>
                                        <span
                                            className={`badge d-flex align-items-center ${item.status?.toLowerCase() == "in progress"
                                                ? "progress"
                                                : item.status?.toLowerCase() == "overdue"
                                                    ? "overdue"
                                                    : item.status?.toLowerCase() == "complete" ||
                                                        item.status?.toLowerCase() == "completee" || item.status?.toLowerCase() == "completed"
                                                        ? "complete"
                                                        : item.status?.toLowerCase() == "skipped"
                                                            ? "skipped"
                                                            : ""
                                                }`}
                                            style={{ 'gap': '10px', cursor: item.status?.toLowerCase() === "skipped" ? "pointer" : 'default' }}
                                        >
                                            {item.status}
                                            {item.status?.toLowerCase() == "skipped" && (
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.6275 1.75L12.25 5.3725V12.25H1.75V1.75H8.6275ZM8.6275 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V5.3725C13.75 4.975 13.5925 4.5925 13.3075 4.315L9.685 0.6925C9.4075 0.4075 9.025 0.25 8.6275 0.25ZM3.25 9.25H10.75V10.75H3.25V9.25ZM3.25 6.25H10.75V7.75H3.25V6.25ZM3.25 3.25H8.5V4.75H3.25V3.25Z" fill="#5720B7" />
                                                </svg>
                                            )}
                                        </span>
                                    </div>
                                </Dropdown.Item>
                            ))}
                            </>
                        )}
                        {/* Previous Section */}
                        {previousRanges?.length > 0 && (
                            <>
                        <small className="text-muted mt-2 d-block">PREVIOUS</small>
                        {previousRanges.map((item, index) => (
                               <Dropdown.Item
                                   key={index}
                                   active={cycleId === item.cycleId}
                                   onClick={() => onSelect(item)}
                               >
                                   <div className="d-flex justify-content-between align-items-center">
                                       <span>{item.label}</span>
                                       <span
                                           className={`badge d-flex align-items-center ${item.status?.toLowerCase() == "in progress"
                                               ? "progress"
                                               : item.status?.toLowerCase() == "overdue"
                                                   ? "overdue"
                                                   : item.status?.toLowerCase() == "complete" ||
                                                       item.status?.toLowerCase() == "completee" || item.status?.toLowerCase() == "completed"
                                                       ? "complete"
                                                       : item.status?.toLowerCase() == "skipped"
                                                           ? "skipped"
                                                           : ""
                                               }`}
                                           style={{ 'gap': '10px', cursor: item.status?.toLowerCase() === "skipped" ? "pointer" : 'default' }}>
                                           {item.status}
                                           {item.status?.toLowerCase() == "skipped" && (
                                               <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                   <path d="M8.6275 1.75L12.25 5.3725V12.25H1.75V1.75H8.6275ZM8.6275 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V5.3725C13.75 4.975 13.5925 4.5925 13.3075 4.315L9.685 0.6925C9.4075 0.4075 9.025 0.25 8.6275 0.25ZM3.25 9.25H10.75V10.75H3.25V9.25ZM3.25 6.25H10.75V7.75H3.25V6.25ZM3.25 3.25H8.5V4.75H3.25V3.25Z" fill="#5720B7" />
                                               </svg>
                                           )}
                                       </span>
                                   </div>
                               </Dropdown.Item>
                           ))}
                            </>
                       )}
                        {noMatches && (
                        <div className="text-muted d-flex align-items-center justify-content-center py-3" style={{ fontSize: '12px' }}>No matches found</div>
                        )}

                    </div>
                </Dropdown.Menu>
            </Dropdown>                            
            </div>
        );
    }
}

export default DateRangeDropdown;
